import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
import { JQ_TOKEN } from '../../core/jquery.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  oldPassword: string;
  newPassword: string;
  emailProvided: string;
  error: string;

  constructor(private auth: AuthService, private toaster: ToasterService, private router: Router, @Inject(JQ_TOKEN) private $: any) {}

  ngOnInit() {
    this.setEmail();
  }

  private setEmail() {
    try {
      this.emailProvided = this.auth.getEmailFromToken();
    } catch (error) {
      console.error(`Error fetching email from token, user has no valid session`);
      this.toaster.pop(`error`, `You must logged in to change password`);
    }
  }

  async onReset() {
    this.error = '';
    this.$('#loading-modal').modal();
    try {
      await this.auth.resetPassword(this.emailProvided, this.oldPassword, this.newPassword);
      this.toaster.pop(`success`, `Successfully changed password`);
      localStorage.clear(); // remove session on succesful reset
      this.router.navigate(['/signin']);
    } catch (error) {
      this.$('#loading-modal').modal('hide');
      console.error('Error changing password ' + error.message);
      this.error = error.message ? `Error changing password: ${error.message}` : `Error: ${error}`;
    }
    this.$('#loading-modal').modal('hide');
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/reset-password/reset-password.component.ts